/**
 * Variant-aware personalization gate.
 * Shows/requires the name-number box only while a variant tagged as
 * "Add Personalization" (via the product's "Personalization" option) is
 * selected. Pairs with snippets/personalization-field-variant.liquid.
 *
 * Detects variant changes by polling the hidden variant-id field rather
 * than relying on a specific theme's swatch/select change event, since
 * swatch libraries often update it programmatically without firing one.
 */
(function () {
  'use strict';

  function parseIds(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function init() {
    var wrapper = document.getElementById('personalization-variant-wrapper');
    if (!wrapper) return; // product has no "Personalization" option — do nothing

    var requiredIds = parseIds(wrapper.getAttribute('data-required-variants'));
    if (!requiredIds.length) return;

    var input = document.getElementById('personalization-variant-name');
    var errorMsg = document.getElementById('personalization-variant-error');

    var form = wrapper.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var variantIdField = form.querySelector('input[name="id"]');
    if (!variantIdField) return;

    var addBtns = form.querySelectorAll('[type="submit"], .btn-add-to-cart, #AddToCart, [name="add"]');

    function isActive() {
      return requiredIds.indexOf(String(variantIdField.value)) !== -1;
    }

    function showError() {
      errorMsg.style.display = 'block';
      input.setAttribute('aria-invalid', 'true');
      input.classList.add('personalization-input--error');
      input.focus();
    }

    function clearError() {
      errorMsg.style.display = 'none';
      input.removeAttribute('aria-invalid');
      input.classList.remove('personalization-input--error');
    }

    function syncVisibility() {
      if (isActive()) {
        wrapper.style.display = '';
      } else {
        wrapper.style.display = 'none';
        clearError();
      }
    }

    input.addEventListener('input', clearError);

    var lastValue = variantIdField.value;
    syncVisibility();
    setInterval(function () {
      if (variantIdField.value !== lastValue) {
        lastValue = variantIdField.value;
        syncVisibility();
      }
    }, 200);

    form.addEventListener('submit', function (e) {
      if (isActive() && input.value.trim() === '') {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError();
        return false;
      }
    });

    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (isActive() && input.value.trim() === '') {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError();
        }
      }, true); // capture phase so we run before the theme's own handler
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
